import React from 'react';
import { ComponentSkinProps } from '../../../../types/component-skin';
import '../ImageText.css';

/**
 * ImageText 컴포넌트의 기본 스킨
 * 이미지와 텍스트를 나란히 배치하는 기본 레이아웃
 */
interface BasicImageTextSkinProps extends ComponentSkinProps {
  // 추가 props가 필요한 경우 여기에 정의
}

const BasicImageTextSkin: React.FC<BasicImageTextSkinProps> = (props) => {
  // props에서 data와 actions, utils 추출
  const {
    data: {
      id,
      imageUrl,
      imagePosition,
      useSecondImage,
      secondImageUrl,
      textContent,
      componentStyle,
      imageContainerStyle,
      secondContainerStyle
    },
    actions,
    utils: { t },
    app,
    editor,
    mode
  } = props;

  return (
    <div id={id} className="image-text-component" style={componentStyle}>
      <div className="image-container" style={imageContainerStyle}>
        <img 
          src={imageUrl} 
          alt={t('이미지')} 
          style={{ width: '100%', borderRadius: '0' }} 
        />
      </div>
      
      {useSecondImage ? (
        // 두 번째 이미지 컨테이너
        <div className="image-container second-image" style={secondContainerStyle}>
          <img 
            src={secondImageUrl} 
            alt={t('두 번째 이미지')} 
            style={{ width: '100%', borderRadius: '0' }} 
          />
        </div>
      ) : (
        // 기존 텍스트 컨테이너
        <div className="text-container" style={secondContainerStyle}>
          <div 
            className="text-content" 
            dangerouslySetInnerHTML={{ __html: textContent }}
          />
        </div>
      )}
      
      {/* 에디터 모드에서 편집 힌트 표시 */}
      {mode === 'editor' && editor?.isSelected && (
        <div className="editor-hint" style={{
          position: 'absolute',
          top: '5px',
          right: '5px',
          background: 'rgba(0, 123, 255, 0.1)',
          color: '#007bff',
          padding: '2px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          pointerEvents: 'none'
        }}>
          {t('이미지-텍스트')}
        </div>
      )}
    </div>
  );
};

export default BasicImageTextSkin;